import VChart from "vue-echarts";
import { getCurrentTheme } from "@/utils/util";
import { UI_THEMES } from "@/utils/const";
import { use } from "echarts/core";
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
  TooltipComponent,
} from "echarts/components";
import { LineChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

const install = (Vue, options) => {
  console.log("FChart plugin installed");
  use([
    GridComponent,
    TooltipComponent,
    ToolboxComponent,
    LegendComponent,
    DataZoomComponent,
    LineChart,
    CanvasRenderer,
  ]);
  Vue.component("FChart", {
    name: "FChart",
    ...VChart,
    props: {
      ...VChart.props,
      theme: {
        type: String,
        default: getCurrentTheme() === UI_THEMES.DARK ? "dark" : "light",
      },
    },
  });
};

export { install };
